import React, { useEffect } from "react";
import { FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData, { siteConfig } from "../Datas/productData";

const highlights = [
  { id: 4, image: "/img/campaign/card-heritage.png", title: "Heritage Recut", eyebrow: "Forms, reconsidered" },
  { id: 5, image: "/img/campaign/card-geometry.png", title: "New Geometry", eyebrow: "The Fold" },
  { id: 6, image: "/img/campaign/card-soft-structure.png", title: "Soft Structure", eyebrow: "Everyday ease" },
  { id: 21, image: "/img/campaign/card-indigo.png", title: "Indigo Ease", eyebrow: "Washed texture" },
];

function Main() {
  useEffect(() => {
    document.title = `${siteConfig.displayName} | Considered Bags & Accessories`;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", siteConfig.description);
  }, []);

  return (
    <main className="home-page">
      <section className="home-hero">
        <img
          src="/img/campaign/hero-awmeadow.png"
          alt="Awmeadow leather shoulder bag in a meadow-side modern pavilion"
          loading="eager"
        />
        <div className="home-hero__shade" />
        <div className="home-hero__content">
          <p>Autumn / Winter 2026</p>
          <h1>Made for the city</h1>
          <span>
            Clear shapes, soft leather and room for the life in between.
          </span>
          <Link to="/shop?collection=New" onClick={() => window.scrollTo(0, 0)}>
            Discover new arrivals <FiArrowRight aria-hidden="true" />
          </Link>
        </div>
      </section>

      <section className="home-highlights" aria-label="Current collections">
        <div className="home-highlights__grid">
          {highlights.map((highlight) => {
            const item = productData.find((product) => product.id === highlight.id);
            if (!item) return null;
            return (
              <Link
                to={`/shopDetails/${item.id}`}
                className="home-highlight"
                key={item.id}
                onClick={() => window.scrollTo(0, 0)}
              >
                <img src={highlight.image} alt={`${highlight.title} original Awmeadow editorial`} loading="lazy" />
                <div>
                  <p>{highlight.eyebrow}</p>
                  <h3>{highlight.title}</h3>
                  <span>Explore the story</span>
                </div>
              </Link>
            );
          })}
        </div>
      </section>

      <section className="home-campaign home-campaign--slouchy">
        <img
          src="/img/campaign/highlight-slouchy-awmeadow.png"
          alt="Original editorial scene featuring a soft slouchy leather bag"
          loading="lazy"
        />
        <div className="home-campaign__content">
          <p>New season</p>
          <h2>Slouchy styles</h2>
          <span>Soft forms. Strong character. Always in motion.</span>
          <Link
            to="/shop?category=Shoulder%20Bags"
            onClick={() => window.scrollTo(0, 0)}
          >
            Shop the edit <FiArrowRight aria-hidden="true" />
          </Link>
        </div>
      </section>

      <section className="home-campaign home-campaign--travel">
        <img
          src="/img/campaign/highlight-travel-awmeadow.png"
          alt="Original city travel scene with an unbranded weekend bag"
          loading="lazy"
        />
        <div className="home-campaign__content">
          <p>City to coast</p>
          <h2>Travel bags</h2>
          <span>Ready for one night away or a change of plans.</span>
          <Link
            to="/shop?category=Shoppers"
            onClick={() => window.scrollTo(0, 0)}
          >
            Find your companion <FiArrowRight aria-hidden="true" />
          </Link>
        </div>
      </section>

    </main>
  );
}

export default Main;
